export const ALL_FILTER_OPTIONS = [
  { value: "text", label: "Text" },
  // { value: "page_content", label: "Page content" },
  // { value: "location", label: "Location" },
  // { value: "plain_text", label: "Plain text" },
  // { value: "formatted_text", label: "Formatted text" },
  { value: "select", label: "Select" },
  // { value: "multi_select", label: "Multi select" },
  // { value: "number", label: "Number" },
  // { value: "date", label: "Date" },
  // { value: "url", label: "Url" },
  // { value: "phone", label: "Phone" },
  // { value: "person", label: "Person" },
  // { value: "space", label: "Space" },
  // { value: "image", label: "Image" },
  // { value: "video", label: "Video" },
  // { value: "file", label: "File" },
  // { value: "created_by", label: "Created by" },
  // { value: "created_time", label: "Created time" },
  // { value: "last_edited_by", label: "Last edited by" },
  // { value: "last_edited_time", label: "Last edited time" }
];

export const ALL_FILTER_MEMBER_VISIBILITY = [
  { value: "card", label: "On profile card" },
  { value: "profile", label: "On profile" },
  { value: "managers", label: "Managers only" }
];

const _selectSort = [
  { value: "manual", label: "Manual" },
  { value: "alphabetical", label: "Alphabetical" },
  { value: "reverse_alphabetical", label: "Reverse alphabetical" }
];

const _numberFormat = [
  { value: "number", label: "Number", decimal_places: 2 },
  { value: "percent", label: "Percent", decimal_places: 2 },
  { value: "dollar", label: "Dollar", decimal_places: 2 },
  { value: "pound", label: "Pound", decimal_places: 2 },
  { value: "euro", label: "Euro", decimal_places: 2 }
];

const _dateFormat = [
  { value: "full_date", label: "Full date" },
  { value: "MM/DD/YYYY", label: "Month/Day/Year" },
  { value: "DD/MM/YYYY", label: "Day/Month/Year" },
  { value: "YYYY/MM/DD", label: "Year/Month/Day" }
];

export const ALL_FILTER_PROPERTIES = {
  "select": {
    sort: _selectSort,
    default_value: "manual",
    show_options: true
  },
  "multi_select": {
    sort: _selectSort,
    default_value: "manual",
    show_options: true
  },
  "number": {
    format: _numberFormat,
    default_value: "number"
  },
  "date": {
    format: _dateFormat,
    includeTime: true,
    default_value: "full_date"
  },
  "person": {
    limit: true,
    // options: [
    //   { value: "all", label: "All people in space" },
    //   { value: "managers", label: "Managers" }
    // ],
    // show_options: true
  },
  "space": {
    limit: true,
    // show_options: true
  }
};

export function reorderOptions(array, from, to) {
  const newArray = array.slice();

  if (
    from < 0 ||
    from >= newArray.length ||
    to < 0 ||
    to >= newArray.length
  ) {
    return newArray;
  }

  const item = newArray.splice(from, 1)[0];
  newArray.splice(to, 0, item);

  return newArray.map((item, index) => ({
    ...item,
    sort_order: index
  }));
};

export const generateUniqueName = (baseName, data) => {
  let count = 0;
  let candidate = baseName;

  while (data.some(item => item.name.toLowerCase() === candidate.toLowerCase())) {
    count += 1;
    candidate = `${baseName} ${count}`;
  }

  return candidate;
};

export const generateKeyFromName = (name) => {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^\w_]/g, '');
};

export const getOptionKey = (format) => {
  switch (format) {
    case "select":
    case "multi_select":
      return "sort";
    case "number":
    case "date":
      return "format";
    default:
      return "limit";
  }
};

export const sortByName = (data, sortType = "manual") => {
  const array = Array.isArray(data) ? data : [];
  const compare = (a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, {
      numeric: true,
      sensitivity: 'base'
    });

  if (sortType === "alphabetical") {
    return [...array].sort(compare);
  }

  if (sortType === "reverse_alphabetical") {
    return [...array].sort((a, b) => compare(b, a));
  }

  return array.map((item, index) => ({
    ...item,
    sort_order: index
  }));
};

export const getFilterColors = (theme) => {
  return [
    { name: "Red", value: theme.colors.red[1] },
    { name: "Pink", value: theme.colors.pink[1] },
    { name: "Grape", value: theme.colors.grape[1] },
    { name: "Violet", value: theme.colors.violet[1] },
    { name: "Indigo", value: theme.colors.indigo[1] },
    { name: "Blue", value: theme.colors.blue[1] },
    { name: "Cyan", value: theme.colors.cyan[1] },
    { name: "Teal", value: theme.colors.teal[1] },
    { name: "Green", value: theme.colors.green[1] },
    { name: "Lime", value: theme.colors.lime[1] },
    { name: "Yellow", value: theme.colors.yellow[1] },
    { name: "Orange", value: theme.colors.orange[1] },
    { name: "Gray", value: theme.colors.gray[3] },
    { name: "Black", value: "#000000" },
    { name: "Default", value: "#f3f3f3" }
  ];
};